import { useMutation } from "@tanstack/react-query"
import type { InferRequestType, InferResponseType } from "hono/client"
import { useNavigate } from "react-router"
import { toast } from "sonner"
import { apiClient, getData } from "../../lib/apiClient"

const req = apiClient.auth.register.$post
export type RegisterInput = InferRequestType<typeof req>["json"]
export type RegisterResponse = InferResponseType<typeof req>

export const useRegister = (redirectPath?: string) => {
	const navigate = useNavigate()
	return useMutation({
		mutationFn: async (input: RegisterInput) => {
			const response = await apiClient.auth.register.$post({ json: input })

			return getData(response)
		},
		onSuccess: () => {
			if (redirectPath) {
				navigate(redirectPath)
			}

			toast.success("Registration successful")
		},
	})
}
